




































import Vue from 'vue'
import Component from 'vue-class-component'
import RespondecoOrganisationSelect from '@/shared/components/respondeco-organisation-select.vue'
import { OrganisationLite } from '@/business/organisation/interfaces/organisation-lite'
import { Injector } from '@/config/dependency-injection'
import { Focusable } from '@/shared/interfaces/focusable'
import { RouterToken } from '@/config/injection-tokens'
import { VueRouter } from 'vue-router/types/router'

@Component({
  components: { RespondecoOrganisationSelect },
})
export default class EmptyChatArea extends Vue implements Focusable {
  private router = Injector.get<VueRouter>(RouterToken)

  public focus() {
    const focusable: Focusable = (this.$refs.organisationChooser as unknown) as Focusable

    focusable.focus()
  }

  public showNew(organisation: OrganisationLite) {
    this.router.push({
      name: 'inbox',
      params: {
        organisation: String(organisation.id),
      },
    })
  }
}
